export const getPicardanFranceData = () => ({
  name: "Picardan",
  country: "France",
  description: "Picardan est un cépage rouge très rare originaire du sud de la France, principalement cultivé dans l'appellation Châteauneuf-du-Pape où il apporte des notes minérales uniques.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "25 ha", percentage: "1%", description: "Cépage très rare, apportant des notes minérales" },
    { name: "Côtes du Rhône", area: "5 ha", percentage: "0.2%", description: "Utilisé dans quelques assemblages traditionnels" },
    { name: "Languedoc-Roussillon", area: "5 ha", percentage: "0.1%", description: "Cultivé dans quelques domaines expérimentaux" },
    { name: "Autres", area: "5 ha", percentage: "0.1%", description: "Dispersé dans le sud de la France" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 1 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#6d2c7a", size: 1 }
  ],
  characteristics: {
    viticulture: "Cépage très rare et difficile à cultiver, sensible aux maladies",
    climate: "Préfère les climats chauds et secs du sud de la France",
    soil: "Sols calcaires et argileux, bien drainés"
  },
  wineStyles: {
    red: "Vins rouges minéraux avec des notes de pierre à fusil et d'élégance"
  },
  foodPairing: "Viandes blanches, volailles, poissons, cuisine provençale, fromages frais",
  history: "Picardan est un cépage très ancien et rare, mentionné dans les textes historiques. Son nom pourrait être lié à la région de Picardie ou à une caractéristique particulière du cépage. Il est aujourd'hui principalement cultivé dans Châteauneuf-du-Pape où il apporte des notes minérales uniques aux assemblages."
}); 